
import { computed, defineComponent, PropType } from 'vue'

import PreTripStatusIcon from '@/modules/TMSModule/components/PreTripStatusIcon/index.vue'

import { preTrip } from '@/core/types/tms-graph.types'

import useAccount from '@/common/composable/useAccount'

export default defineComponent({
    components: {
        PreTripStatusIcon,
    },
    props: {
        item: {
            type: Object as PropType<preTrip>,
            required: true,
        },
    },
    emits: ['open-details', 'open-transfer'],
    setup(props, { emit }) {
        const { havePermissions } = useAccount()

        const openDetails = () => {
            emit('open-details', { ...props.item })
        }

        const openTransfer = () => {
            emit('open-transfer', { ...props.item })
        }

        const isCanTransfer = computed(() => {
            return havePermissions(['tms.pre-trip-reschedule', 'all-root-permission'])
        })

        return {
            openDetails,
            openTransfer,
            isCanTransfer,
        }
    },
})
